module.exports = __webpack_public_path__ + "img/waterlevel.a1266144.png";